import { Script } from 'gatsby';
import React, { useEffect } from 'react';
import EnvironmentUtils from '../../utils/environment.utils';
import { useAnalyticsConsent } from '../../services/analytics/analytics-consent.service';

const GoogleScripts: React.FC = () => {
    const consent = useAnalyticsConsent();

    useEffect(() => {
        if (!EnvironmentUtils.isProd || !consent || typeof window === 'undefined') return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push([
            'consent',
            'update',
            {
                ad_storage: consent === 'accepted' ? 'granted' : 'denied',
                ad_user_data: consent === 'accepted' ? 'granted' : 'denied',
                ad_personalization: consent === 'accepted' ? 'granted' : 'denied',
                analytics_storage: consent === 'accepted' ? 'granted' : 'denied',
            },
        ]);
    }, [consent]);

    return EnvironmentUtils.isProd ? (
        <>
            <Script id="gtag-consent-default">
                {`
                    window.dataLayer = window.dataLayer || [];
                    function gtag() { dataLayer.push(arguments); }
                    gtag('consent', 'default', {
                        ad_storage: 'denied',
                        ad_user_data: 'denied',
                        ad_personalization: 'denied',
                        analytics_storage: 'denied',
                        wait_for_update: 500
                    });
                `}
            </Script>
            <Script id="gtag-script">
                {`(function (w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s),
                    dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', 'GTM-KC38BD8');`}
            </Script>
            <Script id="gads-script" src="https://www.googletagmanager.com/gtag/js?id=AW-347601036"></Script>
            <Script id="gads-config-script">
                {`
            window.dataLayer = window.dataLayer || [];
            function gtag() {
                dataLayer.push(arguments);
            }
            gtag('js', new Date());

            gtag('config', 'AW-347601036');
            `}
            </Script>
        </>
    ) : (
        <></>
    );
};

export default GoogleScripts;
